<template>
  <round :device="device">
    <div class="wz">
      <img :src="icon" style="height: 65px;"/>
      <div class="wenzi">
          <div>今日电量：{{device.state.energy || 0}}度</div>
          <div>总计电量：{{device.state.totalEnergy || 0}}度</div>
      </div>
    </div>

    <div slot="footer" class="footer">
      <div v-text="text"></div>
    </div>
  </round>
</template>
<script>
import Round from './Round'
import zone from '@/model/zone'

export default {
  name: 'DeviceSwitch',
  data () {
    return {
      timer: null
    }
  },
  props: {
    device: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  },
  computed: {
    icon () {
      if (this.device.state && this.device.state.state) {
        return require('../assets/images/device/switch/device_switch_e.png')
      } else {
        return require('../assets/images/device/switch/device_switch.png')
      }
    },
    text () {
      if (this.device.state && this.device.state.state) {
        return '已开启'
      } else {
        return '已关闭'
      }
    }
  },
  components: {
    Round
  },
  methods: {
    // 状态定时调取
    async getState () {
      // 获取其他外部其他设备
      let otherExtState = await zone.getOtherExtState(this.device.unique)
      // 更新外部设备列表的状态
      zone.upadataOtherExtState(window.vm.$store.state.otherExtDevices, otherExtState)
    }
  },
  mounted () {
    this.timer && clearInterval(this.timer)
    this.timer = setInterval(() => {
      this.getState()
    }, 1000 * 10)
  },
  deactivated () {
    this.timer && clearInterval(this.timer)
  },
  activated () {
    this.timer && clearInterval(this.timer)
    this.timer = setInterval(() => {
      this.getState()
    }, 1000 * 10)
  }
}
</script>
<style scoped lang="less">
.round {
  .wz {
    position: relative;
    .wenzi {
      text-align: left;
      position: absolute;
      left: -62%;
      width: 200px;
      color: rgba(89, 89, 89, 1);
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
  }
}
</style>
